/*
 * @LastEditors: caobopan
 * @LastEditTime: 2022-12-16 09:51:58
 * @Description: 
 * @FilePath: /starmaker-starvr-officialnew/src/pages/home/components/steam/static.js
 */
import steamicon from "../../img/web_icon_steam.png";
import oculusicon from '../../img/web_icon_oculus.png';
export const steam = [
  {
    img: steamicon,
    desc: 'Download on the',
    title: 'Steam',
    link: 'https://store.steampowered.com/app/2020670/StarMaker_VR/'
  },
  {
    img: oculusicon,
    desc: "Download on the",
    title: 'Oculus',
    link: 'https://www.oculus.com/experiences/quest/4997511816936942/'
  }
]